/* Lucyd Armor PDP v2 */
(function () {
  var root = document.querySelector('.apdp');
  if (!root) return;
  document.body.classList.add('apdp-dark-footer');

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var variantId = root.getAttribute('data-variant-id');

  /* ---------- cart helpers ---------- */
  function addItems(items) {
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    });
  }
  function afterAdd() { window.location.href = routes + 'cart'; }
  function busy(btn, on, label) {
    if (!btn) return;
    if (on) { btn.dataset.label = btn.textContent; btn.textContent = label || 'Adding…'; btn.disabled = true; }
    else { btn.textContent = btn.dataset.label || btn.textContent; btn.disabled = false; }
  }
  function fail(msgEl, btn, err) {
    busy(btn, false);
    if (msgEl) msgEl.textContent = err.message;
  }

  /* main add to cart */
  var form = root.querySelector('[data-product-form]');
  var atcMsg = root.querySelector('[data-atc-msg]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      busy(btn, true);
      addItems([{ id: Number(variantId), quantity: 1 }]).then(afterAdd).catch(function (err) { fail(atcMsg, btn, err); });
    });
  }
  var stickyAdd = root.querySelector('[data-sticky-add]');
  if (stickyAdd) {
    stickyAdd.addEventListener('click', function () {
      busy(stickyAdd, true);
      addItems([{ id: Number(variantId), quantity: 1 }]).then(afterAdd).catch(function (err) { busy(stickyAdd, false); alert(err.message); });
    });
  }

  /* accessories */
  root.querySelectorAll('[data-add-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      busy(btn, true);
      addItems([{ id: Number(btn.getAttribute('data-add-id')), quantity: 1 }]).then(afterAdd).catch(function (err) { busy(btn, false); alert(err.message); });
    });
  });

  /* frequently bought together */
  var fbt = root.querySelector('[data-fbt]');
  if (fbt) {
    var fbtBtn = fbt.querySelector('[data-fbt-add]');
    fbtBtn.addEventListener('click', function () {
      var ids = fbtBtn.getAttribute('data-ids').split(',');
      var extra = fbt.querySelector('[data-fbt-extra]');
      if (extra && extra.checked) ids.push(extra.value);
      busy(fbtBtn, true);
      addItems(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }))
        .then(afterAdd).catch(function (err) { fail(fbt.querySelector('[data-fbt-msg]'), fbtBtn, err); });
    });
  }

  /* lens chooser (LensAdvizor). The app strips <lensadvizor-btn> elements it did not inject,
     so keep one alive in our hidden slot and forward clicks from our own buttons to it. */
  var laSlot = document.querySelector('[data-apdp-la]');
  var laProto = laSlot && laSlot.querySelector('lensadvizor-btn');
  laProto = laProto ? laProto.cloneNode(false) : null;
  var laEnsure = function () {
    if (!laSlot || !laProto || laSlot.querySelector('lensadvizor-btn')) return;
    var b = laProto.cloneNode(false); b.textContent = 'Choose your lenses';
    b.setAttribute('data-la-variant-id', variantId);
    laSlot.appendChild(b);
  };
  if (laSlot && window.MutationObserver) new MutationObserver(laEnsure).observe(laSlot, { childList: true, subtree: true });
  [500, 1500, 3000, 6000].forEach(function (t) { setTimeout(laEnsure, t); });
  root.querySelectorAll('[data-open-lens]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      laEnsure();
      var la = laSlot && laSlot.querySelector('lensadvizor-btn');
      if (la) { la.click(); return; }
      var url = root.getAttribute('data-lens-url');
      if (url) window.location.href = url;
    });
  });

  /* ---------- gallery ---------- */
  var track = root.querySelector('[data-track]');
  if (track) {
    var go = function (i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
    root.querySelector('[data-gallery]').addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb],[data-dot]');
      if (t) go(Number(t.getAttribute('data-thumb') || t.getAttribute('data-dot')));
    });
    var mark = function () {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      root.querySelectorAll('[data-thumb]').forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      root.querySelectorAll('[data-dot]').forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    };
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (e.key === 'ArrowRight') go(i + 1);
      if (e.key === 'ArrowLeft') go(Math.max(i - 1, 0));
    });
  }

  /* Lens variant selector (products with several lens variants, e.g. lucyd-armor) */
  var vJson = root.querySelector('[data-apdp-variants]');
  if (vJson) {
    var variants = [];
    try { variants = JSON.parse(vJson.textContent); } catch (e) {}
    var money = function (c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); };
    /* Title follows the lens (sticky bar + buy box) */
    var titleEl = root.querySelector('.apdp-buy__title');
    var baseTitle = titleEl ? titleEl.textContent : '';
    var setTitle = function (v) {
      var t = variants[0] && v.id === variants[0].id ? baseTitle : 'Armor ' + v.option1;
      if (titleEl) titleEl.textContent = t;
      var st = document.querySelector('.apdp-sticky__title'); if (st) st.textContent = t;
    };
    /* LensAdvizor form shows the product's featured photo; swap it for the selected lens photo */
    var featStem = '';
    var firstImg = function () { var i = track && track.querySelector('img'); return i ? i.getAttribute('src') : ''; };
    var lensImg = firstImg();
    var skip = 'cart-drawer, .cart-drawer, #CartDrawer, cart-notification, .cart-notification';
    var fixLaImg = function () {
      if (!featStem || !lensImg) return;
      document.querySelectorAll('img').forEach(function (img) {
        if (root.contains(img) || img.closest(skip)) return;
        var s = img.getAttribute('src') || '';
        if ((img.hasAttribute('data-apdp-lensimg') || s.indexOf(featStem) > -1) && s !== lensImg) {
          img.setAttribute('src', lensImg); img.removeAttribute('srcset'); img.setAttribute('data-apdp-lensimg', '');
        }
      });
    };
    fetch(routes + 'products/' + root.getAttribute('data-product-handle') + '.js').then(function (r) { return r.json(); }).then(function (p) {
      featStem = String(p.featured_image || '').split('?')[0].split('/').pop().replace(/\.[a-z]+$/i, '');
      fixLaImg();
    }).catch(function () {});
    if (window.MutationObserver) {
      var laRaf;
      new MutationObserver(function () { cancelAnimationFrame(laRaf); laRaf = requestAnimationFrame(fixLaImg); }).observe(document.body, { childList: true, subtree: true });
    }
    var cur = variants.filter(function (x) { return String(x.id) === variantId; })[0];
    if (cur) setTitle(cur);
    root.querySelectorAll('[data-opt-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-opt-val');
        var v = variants.filter(function (x) { return x.option1 === val; })[0];
        if (!v) return;
        variantId = String(v.id);
        root.setAttribute('data-variant-id', variantId);
        root.querySelectorAll('[data-opt-val]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var ov = root.querySelector('[data-optval]'); if (ov) ov.textContent = val;
        root.querySelectorAll('form input[name="id"]').forEach(function (i) { i.value = variantId; });
        document.querySelectorAll('[data-apdp-xp] input[name="id"]').forEach(function (i) { i.value = variantId; });
        document.querySelectorAll('[data-apdp-xp-wrap]').forEach(function (w) { w.hidden = !v.available; });
        var pr = root.querySelector('[data-price]'); if (pr) pr.textContent = money(v.price);
        var sp = document.querySelector('.apdp-sticky__price'); if (sp) sp.textContent = money(v.price);
        var tpl = root.querySelector('template[data-lens-gal="' + val.toLowerCase().replace(/"/g, '') + '"]');
        if (tpl && track) {
          var part = function (p) { var el = tpl.content.querySelector('[data-p="' + p + '"]'); return el ? el.innerHTML : ''; };
          var th = root.querySelector('[data-gal-thumbs]'); if (th) th.innerHTML = part('thumbs');
          var dt = root.querySelector('[data-gal-dots]'); if (dt) dt.innerHTML = part('dots');
          track.innerHTML = part('slides');
          track.scrollLeft = 0;
        }
        setTitle(v);
        lensImg = firstImg();
        fixLaImg();
        root.querySelectorAll('[data-lens-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-lens-panel') !== variantId; });
        document.querySelectorAll('lensadvizor-btn,[data-lensadvizor-btn]').forEach(function (b) { b.setAttribute('data-la-variant-id', variantId); });
        [root.querySelector('[data-atc]'), document.querySelector('[data-sticky-add]')].forEach(function (b) { if (b) b.disabled = !v.available; });
        try { var u = new URL(location.href); u.searchParams.set('variant', variantId); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      });
    });
  }

  /* Product badges from label apps (e.g. "reddot winner") don't know this layout and land on the buy box; put them on the main photo */
  var stage = root.querySelector('.apdp-gallery__stage');
  var aside = root.querySelector('.apdp__aside');
  var badgeRe = /lably|lbl[-_]|badge|label|ribbon/i;
  var unwraps = 0;
  var moveBadges = function () {
    if (!stage) return;
    var found = [];
    if (aside) aside.querySelectorAll('*').forEach(function (el) {
      var c = (typeof el.className === 'string' ? el.className : '') + ' ' + (el.id || '');
      if (/(^|\s)apdp/.test(c) || !badgeRe.test(c)) return;
      found.push(el);
    });
    document.querySelectorAll('body > [class*="lably" i], body > [id*="lably" i]').forEach(function (el) { found.push(el); });
    /* Some label apps wrap our own images (logo, stars) in their container: unwrap the image, keep the badge */
    if (aside && unwraps < 30) aside.querySelectorAll('img').forEach(function (img) {
      var w = img.parentElement;
      if (!w || w === aside || /(^|\s)apdp/.test(typeof w.className === 'string' ? w.className : '')) return;
      unwraps++;
      var holder = document.createElement('div');
      holder.className = 'apdp-badge-moved apdp-badge-holder';
      Array.prototype.slice.call(w.childNodes).forEach(function (n) { if (n !== img) holder.appendChild(n); });
      w.parentNode.insertBefore(img, w);
      w.parentNode.removeChild(w);
      if (holder.childNodes.length && stage) stage.appendChild(holder);
    });
    found.forEach(function (el) {
      if (stage.contains(el) || (aside && !aside.contains(el) && el.parentElement !== document.body)) return;
      el.classList.add('apdp-badge-moved');
      stage.appendChild(el);
    });
  };
  moveBadges();
  [500, 1500, 3000, 6000].forEach(function (t) { setTimeout(moveBadges, t); });
  if (window.MutationObserver && aside) {
    var bRaf;
    new MutationObserver(function () { cancelAnimationFrame(bRaf); bRaf = requestAnimationFrame(moveBadges); }).observe(aside, { childList: true, subtree: true });
  }

  if (root.querySelector('[data-oke-widget]')) {
    var okeTries = 0;
    (function oke() { if (window.okeWidgetApi && window.okeWidgetApi.initAllWidgets) { try { window.okeWidgetApi.initAllWidgets(); } catch (e) {} return; } if (++okeTries < 40) setTimeout(oke, 250); })();
  }

  /* ---------- pick your fit filter ---------- */
  var fit = root.querySelector('[data-fit]');
  if (fit) {
    var tabs = fit.querySelectorAll('[data-filter]');
    var cards = fit.querySelectorAll('[data-groups]');
    var apply = function (f) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-filter') === f ? 'true' : 'false'); });
      cards.forEach(function (c) {
        var g = (c.getAttribute('data-groups') || '').split(',').map(function (s) { return s.trim(); });
        c.hidden = !(f === 'all' || g.indexOf(f) > -1);
      });
    };
    tabs.forEach(function (t) { t.addEventListener('click', function () { apply(t.getAttribute('data-filter')); }); });
    apply(fit.getAttribute('data-default') || 'standard');
  }

  /* ---------- FAQ ---------- */
  root.querySelectorAll('.apdp-faq__item').forEach(function (item) {
    var q = item.querySelector('.apdp-faq__q');
    q.addEventListener('click', function () {
      var open = item.getAttribute('data-open') !== 'true';
      item.setAttribute('data-open', open ? 'true' : 'false');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Sticky bar: move it to <body> so theme section animations (transforms) can't trap position:fixed; hide near footer */
  var sticky = root.querySelector('[data-sticky]');
  if (sticky) {
    var host = document.createElement('div');
    host.className = 'apdp apdp-sticky-host';
    host.appendChild(sticky);
    document.body.appendChild(host);
    /* Shopify's theme-preview bar is fixed to the bottom on preview links; sit above it (no-op on the live store) */
    var lift = function () {
      var p = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe, iframe[id*="preview-bar"], iframe[src*="preview_bar"]');
      var h = 0;
      if (p) { var r = p.getBoundingClientRect(); if (r.height && r.top < innerHeight && r.bottom >= innerHeight - 2) h = Math.round(innerHeight - r.top); }
      sticky.style.bottom = h + 'px';
    };
    [300, 1000, 2500, 5000].forEach(function (t) { setTimeout(lift, t); });
    addEventListener('resize', lift);
  }
  var foot = document.getElementById('lx-footer') || document.querySelector('body > footer');
  if (sticky && foot && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      sticky.classList.toggle('is-hidden', en[0].isIntersecting);
    }).observe(foot);
  }

  /* ---------- recently viewed ---------- */
  var KEY = 'lucyd_recently_viewed';
  var handle = root.getAttribute('data-product-handle');
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
  var others = list.filter(function (h) { return h !== handle; }).slice(0, 8);
  try { localStorage.setItem(KEY, JSON.stringify([handle].concat(others).slice(0, 12))); } catch (e) {}
  var recent = root.querySelector('[data-recent]');
  var rail = root.querySelector('[data-recent-rail]');
  if (recent && rail && others.length) {
    Promise.all(others.map(function (h) {
      return fetch(routes + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=364';
        return '<a class="apdp-pcard" href="' + esc(p.url) + '">' +
          '<div class="apdp-pcard__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="182" height="182" loading="lazy">' : '') + '</div>' +
          '<div><p class="apdp-pcard__brand">' + esc(p.vendor) + '</p><p class="apdp-pcard__name">' + esc(p.title) + '</p></div>' +
          '<span class="apdp-btn-black">Shop now</span></a>';
      }).join('');
      if (html) { rail.innerHTML = html; recent.hidden = false; }
    });
  }
})();
